"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PortalWithBackdrop;
var _react = _interopRequireWildcard(require("react"));
var _Portal = _interopRequireDefault(require("./Portal"));
var _Backdrop = _interopRequireDefault(require("./Backdrop"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function PortalWithBackdrop(props) {
  var backdropStyle = props.backdropStyle,
    children = props.children,
    onClose = props.onClose;
  function handleEscape(event) {
    if (event.keyCode === 27) {
      // Do whatever when esc is pressed
      onClose();
    }
  }
  (0, _react.useEffect)(function () {
    // Lock window from scrolling
    // document.body.style.overflow = 'hidden'
    document.body.style.overscrollBehavior = 'none';
    document.addEventListener("keydown", handleEscape);
    return function () {
      // Unlock window from scrolling
      // document.body.style.overflow = 'auto'
      document.body.style.overscrollBehavior = 'auto';
      document.removeEventListener("keydown", handleEscape);
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_Portal["default"], null, /*#__PURE__*/_react["default"].createElement(_Backdrop["default"], {
    style: backdropStyle,
    onPress: onClose
  }), children);
}